import { GetAdminWebEnums, GetWebEnums } from '@/apis/enums'
export default {
  state: () => {
    return {
      enumsData: null
    }
  },
  mutations: {
    // 清理枚举数据
    emptyEnums(state, data) {
      state.enumsData = null
    },

    setEnums(state, data) {
      state.enumsData = data
    }
  },
  actions: {
    // 获取系统枚举值
    async getEnumsData(context, data) {
      try {
        const { data: adminWebEnumsData } = await GetAdminWebEnums()
        context.commit('setEnums', adminWebEnumsData)
      } catch (error) {}
    }
  }
}
